import * as React from 'react'
import { ReactElement, useState } from 'react'
import { useFormikContext } from 'formik'
import { Button } from '@fluentui/react-components'
import { bundleIcon, DataBarVerticalAddFilled, DataBarVerticalAddRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { FileMutationDto } from '../../../../config/fileConfig'
import BaseList from '../../../List/BaseList'
import { FileSurchargeListItem } from './FileSurchargeListItem'
import FileSurchargeDialog from './FileSurchargeDialog'

export type FileSurchargeDto = {
    id: string
    surchargeType: string
    name: string
    value: string
}

export enum SurchargeAction {
    ADD = 'add',
    EDIT = 'edit',
}

function newSurchargeValue(): FileSurchargeDto {
    return {
        id: undefined,
        name: '',
        surchargeType: undefined,
        value: '0.0',
    }
}

const DataBarVerticalAddIcon = bundleIcon(DataBarVerticalAddRegular, DataBarVerticalAddFilled)

export default function FileSurchargeList(): ReactElement {
    const { t: translate } = useTranslation()
    const { values, setFieldValue } = useFormikContext<FileMutationDto>()
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [index, setIndex] = useState(null)
    const [action, setAction] = useState<SurchargeAction>()

    const addNewSurcharge = () => {
        const surcharges = [...(values.surcharges ? values.surcharges : []), newSurchargeValue()]
        setFieldValue('surcharges', surcharges)
        setAction(SurchargeAction.ADD)
        setIndex(surcharges.length - 1)
        setOpenDialog(true)
    }
    const editSurcharge = (index: number) => {
        setAction(SurchargeAction.EDIT)
        setIndex(index)
        setOpenDialog(true)
    }

    return (
        <>
            <Button
                style={{ marginTop: 10 }}
                appearance="primary"
                icon={<DataBarVerticalAddIcon />}
                onClick={addNewSurcharge}
            >
                {translate('file.edit.form.finance.surcharges.add')}
            </Button>
            {values.surcharges?.length > 0 && (
                <BaseList<FileSurchargeDto> items={values.surcharges}>
                    {(item: FileSurchargeDto, index: number) => (
                        <FileSurchargeListItem index={index} item={item} edit={editSurcharge} />
                    )}
                </BaseList>
            )}
            <FileSurchargeDialog
                show={openDialog}
                setOpen={setOpenDialog}
                initialValues={values.surcharges?.[index]}
                index={index}
                action={action}
            />
        </>
    )
}
